// extracted by mini-css-extract-plugin
export var imageSupport = "SupportImageTextBlock-module--imageSupport--731f1";
export var workingdaywrapper = "SupportImageTextBlock-module--workingdaywrapper--64a03";
export var wrapper = "SupportImageTextBlock-module--wrapper--44a63";